import type { ProductListItem } from '@providers/ProductListProvider';
import { useMemo } from 'react';

export type useProductProps = Pick<
  ProductListItem,
  'tags' | 'available' | 'images_info' | 'price_min' | 'compare_at_price_min'
>;

export const useProduct = (
  { tags, available, images_info, price_min, compare_at_price_min }: useProductProps,
  noImageUrl?: string
) => {
  // TODO: Performance - Refactor -> Only needs these props
  // const {tags, available, images_info, price_min, compare_at_price_min} = product;

  const labelByTag = useMemo(() => {
    return tags
      ?.filter((item) => item.indexOf('pfs:label') !== -1)
      .map((item) => item.split('pfs:label-')[1]);
  }, [tags]);

  const isSoldOut = !available;

  const previewProductImages = useMemo(() => {
    const productInfo = images_info;

    if (!productInfo.length) {
      return [noImageUrl || ''];
    }

    if (productInfo.length === 1) {
      return [productInfo[0].src];
    }

    return [productInfo[0].src, productInfo[1].src];
  }, [images_info]);

  const isSale = useMemo(() => {
    return (compare_at_price_min || 0) > price_min;
  }, [compare_at_price_min, price_min]);

  const salePercent = useMemo(() => {
    return isSale && compare_at_price_min
      ? Math.round((((compare_at_price_min || 0) - price_min) * 100) / compare_at_price_min) + '%'
      : undefined;
  }, [compare_at_price_min, price_min]);

  const saleAmount = useMemo(() => {
    return isSale ? (compare_at_price_min || 0) - price_min : undefined;
  }, [compare_at_price_min, price_min]);

  const firstImage = images_info.length > 0 ? images_info[0] : undefined;

  return {
    firstImage,
    labelByTag,
    isSoldOut,
    isSale,
    salePercent,
    saleAmount,
    previewProductImages,
  };
};

export default useProduct;
